module.exports = __webpack_public_path__ + "static/media/202.e486611a.webp";